import md5 from "md5";

export const gpsstModule = {
  state: {
    gpsst: {}
  },
  mutations: {
    // obligatoirement synchrones
    // persistance des données dans le store
    INITIALIZE_GPSST(state, value) {
      state.gpsst = value;
    },
    OVERWRITE_GPSST(state, value) {
      state.gpsst = value;
    }
  },
  actions: {
    // asynchrone possible
    /** initialisation des données GPSST */
    initializeState(context, value) {
      var completedData = value.appData;
      completedData.appName = value.appName;
      completedData.dataName = value.dataName;
      completedData.dataType = value.dataType;
      completedData.dataTypeVersion = value.dataTypeVersion;

      completedData.id_counter = 0;

      completedData.compagnyContext = {};
      completedData.compagnyContext.name = "";
      completedData.compagnyContext.unitName = "";
      completedData.compagnyContext.unitWorkcomment = "";
      completedData.compagnyContext.stakeholders = [];
      completedData.compagnyContext.stakeholders.push({
        name: "",
        function: "",
        involvementMode: ""
      });
      completedData.compagnyContext.completionPeriods = {};
      completedData.compagnyContext.completionPeriods.currentDate = "";
      completedData.compagnyContext.completionPeriods.previousDate = "";
      completedData.compagnyContext.informationCollect = [];
      completedData.compagnyContext.informationCollect.push({
        event: "",
        period: ""
      });
      completedData.compagnyContext.evaluationWorkcomments = "";

      // initialisation des champs personalisés des thèmes

      for (let theme = 0; theme < completedData.themes.length; theme++) {
        let currentTheme = completedData.themes[theme];
        //currentTheme = {...currentTheme, randomNumber:Math.random()};
        currentTheme.randomNumber = Math.random();
        currentTheme.analysis = "";
        currentTheme.custom = false;
        currentTheme.globalRating = {};
        currentTheme.globalRating.rating = null;
        currentTheme.globalRating.automatic = true;

        currentTheme.progressProposals = [];
        currentTheme.progressProposals.push({
          title: "",
          prioritize: false,
          actions: "",
          deliverables: "",
          date: null,
          actors: ""
        });
        currentTheme.status = "empty";

        // initialisation des données personnalisés des sous-thèmes
        for (let subtheme in currentTheme.subThemes) {
          // ajout des champs custom et rating au sous thème
          currentTheme.subThemes[subtheme].custom = false;
          currentTheme.subThemes[subtheme].rating = null;

          // initialisation des champs personnalisés des descriptions des sous-thèmes
          for (let description in currentTheme.subThemes[subtheme]
            .situationDescriptions) {
            currentTheme.subThemes[subtheme].situationDescriptions[
              description
            ].marking = "";
            currentTheme.subThemes[subtheme].situationDescriptions[
              description
            ].custom = false;
          }
        }
        // initialisation des champs personnalisés des elements d'objectivation
        for (let objectification in currentTheme.objectificationElements) {
          currentTheme.objectificationElements[objectification].marking = "";
          currentTheme.objectificationElements[objectification].custom = false;
        }

        // tri des sous-thèmes en fonction de leur displayOrder
        completedData.themes[theme].subThemes.sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        });
      }

      // tri des slices par ordre croissant
      completedData.slices.sort(function(a, b) {
        return a.num - b.num;
      });

      // envoi pour mutation du store - passage pour le session storage afin de résoudre le problème de format de données
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(completedData),
        jsonMd5 = md5(jsonStr);
      window.sessionStorage.setItem("gpsst", jsonStr);
      window.sessionStorage.setItem("gpsst_md5_initial", jsonMd5);

      context.commit(
        "INITIALIZE_GPSST",
        JSON.parse(sessionStorage.getItem("gpsst"))
      );
    },

    /** Ecrase le contexte GPSST actuel à partir d'un nouvel objet context et l'enregistre dans le store et le sessionStorage
     * @param {Object} context - le contexte à mettre à jour
     * @param {Object} newContext - le nouveau context qui remplace l'ancien
     */
    overwriteGpsst(context, newContext) {
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(newContext);
      window.sessionStorage.setItem("gpsst", jsonStr);

      context.commit("OVERWRITE_GPSST", newContext);
    },

    /** Ecrase le contexte ENTREPRISE actuel à partir d'un nouvel objet context et l'enregistre dans le store et le sessionStorage
     * @param {Object} context - le contexte à mettre à jour
     * @param {Object} newContext - le nouveau context qui remplace l'ancien
     */
    overwriteCompagnyContext(context, newContext) {
      context.state.gpsst.compagnyContext = newContext;
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(context.state.gpsst);
      window.sessionStorage.setItem("gpsst", jsonStr);

      context.commit("OVERWRITE_GPSST", context.state.gpsst);
    },

    /** Ajoute un thème dans GPSST et met à jour le sessionStorage
     * @param {Object} context - le contexte à mettre à jour
     * @param {Object} newtheme - titre et abbréviation du nouveau thème
     */
    addTheme(context, newtheme) {
      var ref = context.state.gpsst.id_counter++;
      context.state.gpsst.themes.push({
        ref: "TH" + ref.toString(),
        abbreviation: newtheme.abbr,
        title: newtheme.title,
        chapo: "",
        detail: "",
        subThemes: [],
        objectificationElements: [],
        custom: true,
        globalRating: {
          automatic: true,
          rating: null
        },
        progressProposals: [
          {
            title: "",
            prioritize: false,
            actions: "",
            deliverables: "",
            date: null,
            actors: ""
          }
        ],
        analysis: "",
        status: "empty"
      });
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(context.state.gpsst);
      window.sessionStorage.setItem("gpsst", jsonStr);

      context.commit("OVERWRITE_GPSST", context.state.gpsst);
    },

    /** Supprimer un thème dans GPSST et met à jour le sessionStorage
     * @param {Object} context - le contexte à mettre à jour
     * @param {Object} data - data.params.themeAbbr doit être l'abréviation du thème à supprimer
     */
    deleteTheme(context, data) {
      for (let i = 0; i < context.state.gpsst.themes.length; i++) {
        if (
          context.state.gpsst.themes[i].abbreviation == data.params.themeAbbr
        ) {
          context.state.gpsst.themes.splice(i, 1);
        }
      }
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(context.state.gpsst);
      window.sessionStorage.setItem("gpsst", jsonStr);

      context.commit("OVERWRITE_GPSST", context.state.gpsst);
    },

    /** Ajouter ou supprimer un élément à un thème existant
    
     * @param {Object} data - le type d'action à réaliser: "ADD-DESCRIPTION_SITUATION_ELEMENT", ... ainsi que les paramètres nécessaires (abbreviation du theme, ref du sous-theme, ref de la slice, et la nouvelle donnée)
    */
    editThemeElement({ state, commit, dispatch }, data) {
      var ref = null;
      // on recherche le bon theme
      var themes = state.gpsst.themes;
      for (let i = 0; i < themes.length; i++) {
        if (themes[i].abbreviation == data.params.themeAbbr) {
          // renommer le thème
          if (data.type == "RENAME-THEME") {
            themes[i].title = data.params.title;
            themes[i].abbreviation = data.params.abbr;
            break;
          }

          // mettre à jour la note lié au thème
          if (data.type == "RATE-THEME") {
            themes[i].globalRating.rating = data.params.rating;
            themes[i].globalRating.automatic = data.params.automatic;

            // on recalcule le status du thème
            dispatch("setStatus", themes[i]);
            break;
          }

          // mettre à jour l'ensemble des propositions de progrès
          if (data.type == "SET-PROGRESS_PROPOSALS") {
            themes[i].progressProposals = data.params.progressProposals;
          }

          // ajouter un élément d'objectivation
          if (data.type == "ADD-OBJECTIFICATION_ELEMENT") {
            ref = state.gpsst.id_counter++;
            themes[i].objectificationElements.push({
              ref: "OBJ" + ref.toString(),
              sliceRef: data.params.sliceRef,
              custom: true,
              style: "",
              description: data.params.description
            });
            break;
          } // fin ajout élément d'objectivation

          // on recherche le bon element d'objectivation
          var objectificationElements = themes[i].objectificationElements;
          for (let jj = 0; jj < objectificationElements.length; jj++) {
            if (
              objectificationElements[jj].ref == data.params.objectificationRef
            ) {
              // on ajoute un nouveau style à un element d'objectivation
              if (data.type == "SET-MARKING-OBJECTIFICATION_ELEMENT") {
                objectificationElements[jj].marking = data.params.marking;
                break;
              }
              // on edit le contenu de l'élément d'objectivation
              if (data.type == "EDIT-OBJECTIFICATION_ELEMENT") {
                objectificationElements[jj].description =
                  data.params.description;
              }
              // on supprime l'élement d'objectivation
              if (data.type == "DEL-OBJECTIFICATION_ELEMENT") {
                objectificationElements.splice(jj, 1);
                break;
              } // fin suppression élement d'objectivation
            }
          }

          var subThemes = themes[i].subThemes;
          if (data.type == "NEW-SUBTHEME") {
            // on ajoute le nouveau sous-thème
            var displayOrder = 1;
            if (subThemes.length) {
              displayOrder = subThemes[subThemes.length - 1].displayOrder + 1;
            }
            ref = state.gpsst.id_counter++;
            subThemes.push({
              ref: "SUBTH" + ref.toString(),
              title: data.params.description,
              custom: true,
              situationDescriptions: [],
              rating: null,
              displayOrder: displayOrder
            }); // fin ajout du nouveau sous-thème
            // sortir de la boucle for
            break;
          }

          // on recherche le bon sous-theme
          for (let j = 0; j < subThemes.length; j++) {
            if (subThemes[j].ref == data.params.subThemeRef) {
              // on met à jour l'évaluation du theme
              if (data.type == "RATE-SUBTHEME") {
                subThemes[j].rating = data.params.rating;
                // on recalcule le status du thème
                dispatch("setStatus", themes[i]);
                break;
              }

              // on édit le titre tu sous-thème
              if (data.type == "RENAME-SUBTHEME") {
                subThemes[j].title = data.params.description;
              }

              // on supprime le sous-thème
              if (data.type == "DEL-SUBTHEME") {
                subThemes.splice(j, 1);
                break;
              } // fin de la suppression du sous thème

              // on ajoute la nouvelle description de situation
              if (data.type == "ADD-DESCRIPTION_SITUATION_ELEMENT") {
                ref = state.gpsst.id_counter++;
                subThemes[j].situationDescriptions.push({
                  ref: "DE" + ref.toString(),
                  description: data.params.description,
                  sliceRef: data.params.sliceRef,
                  marking: data.params.marking,
                  custom: true
                });
                break;
              } // fin de l'ajout de la nouvelle description

              var situationDescriptions = subThemes[j].situationDescriptions;
              for (let k = 0; k < situationDescriptions.length; k++) {
                if (
                  situationDescriptions[k].ref == data.params.descriptionRef
                ) {
                  // on ajoute un nouveau style à une description de situation
                  if (
                    data.type == "SET-MARKING-DESCRIPTION_SITUATION_ELEMENT"
                  ) {
                    situationDescriptions[k].marking = data.params.marking;
                    break;
                  } // fin de l'ajout d'un nouveau style à une description

                  // on modifie le contenu d'une description de situation
                  if (data.type == "EDIT-DESCRIPTION_SITUATION_ELEMENT") {
                    situationDescriptions[k].description =
                      data.params.description;
                    break;
                  }

                  // on supprime une description de situation
                  if (data.type == "DEL-DESCRIPTION_SITUATION_ELEMENT") {
                    situationDescriptions.splice(k, 1);
                    break;
                  }
                }
              }
            }
          }
        }
      }
      //TODO factoriser les appels similaires
      var jsonStr = JSON.stringify(state.gpsst);
      window.sessionStorage.setItem("gpsst", jsonStr);

      commit("OVERWRITE_GPSST", state.gpsst);
    },
    /** Mettre à jour le 'status' d'un thème donné    
     * @theme {Object} theme - le theme pour lequel le statut doit être recalculé
     */
    setStatus(context, theme) {
      //console.log("gpsstModule.setStatus", theme);

      var nbSubThemes = theme.subThemes.length;

      // On compte le nb de sous-thèmes évalués (= notés ou N/A)
      var ratingDone = 0;
      for (let l = 0; l < nbSubThemes; l++) {
        var subTheme = theme.subThemes[l];
        if (subTheme.rating !== null) {
          // Le sous-thème est noté (rating >= 0) ou N/A (rating = -1)
          ratingDone++;
        }
      }

      // On en déduit le nb de sous-thèmes restés à l'état "à évaluer" (rating===null)
      var ratingNotDone = nbSubThemes - ratingDone;

      // On calcule le statut du thème (cf. SFD §3.73.6	- Écran « Liste des thèmes »)
      if (ratingDone == nbSubThemes && theme.globalRating.rating !== null) {
        // Le thème est traité ("complete") car :
        // - tous les sous-thèmes sont évalués (= marqué « Non concerné » OU possède une cotation)
        // ET
        // - une cotation globale du thème est définie
        theme.status = "complete";
      } else if (
        ratingNotDone == nbSubThemes &&
        theme.globalRating.rating === null
      ) {
        // Le thème est "non traité" ("empty") si tous les sous-thèmes sont non évalués et qu'il n'y pas d'évaluation globale
        theme.status = "empty";
      } else if (
        ratingDone === nbSubThemes &&
        theme.globalRating.rating === null
      ) {
        // Le thème n'est "pas applicable" si tous les sous-thèmes sont évalués et qu'il n'y pas d'évaluation globale
        theme.status = "notApplicable";
      } else {
        // Sinon le thème est "en cours" ("incomplete")
        theme.status = "incomplete";
      }

    }
  }
};
